/**
 * When the url contains key/value pairs, you can get the value by passing the key into this function.
 *
 * @example When location.href = https://magneto.int.guardian.powerschoolcorp.com/calendar/eventinfo/01HS7VRYNEWX95A8VH64AG3JAB, passing in "eventinfo" returns "01HS7VRYNEWX95A8VH64AG3JAB"
 * @example When location.href = https://magneto.int.guardian.powerschoolcorp.com/calendar/student/DSOIJQAWOISDASODKNO/eventinfo/01HS7VRYNEWX95A8VH64AG3JAB, passing in "student" returns "DSOIJQAWOISDASODKNO" and passing in "eventinfo" returns "01HS7VRYNEWX95A8VH64AG3JAB"

 * @param pathParameterKey: The name of the key for the key/value pair that is in the URL.
 * @returns The value for the key/value pair in the URL if it exists.
 */
export function getParamFromUrl(pathParameterKey) {
    const location = window.location;
    const regex = new RegExp(`/${pathParameterKey}/([^/]+)`, 'i');
    const match = location.href.match(regex);
    return match ? match[1] : undefined;
}
/**
 * This function will change the pathname to whatever is passed in without making the page reload/refresh.
 * In this url: https://powerschool.com/calendar/event/soifnsdfkasdas
 * The origin is "https://powerschool.com"
 * The pathName is "calendar/event/soifnsdfkasdas"
 * This function will not change the origin, but it will remove the pathName in favor of the passed in value.
 * @param pathName: The new pathName to set
 */
export function setPathName(pathName) {
    const location = window.location;
    const updatedUrl = `${location.origin}/${pathName}`;
    window.history.pushState({ path: updatedUrl }, '', updatedUrl);
}
